export const getDeviceName = () => window.localStorage.getItem('deviceName');

export const getDeviceParams = () => {
  const deviceName = getDeviceName();
  return deviceName ? { deviceName } : {};
};

export const addDeviceNameToUrl = (url) => {
  const deviceName = getDeviceName();

  if (!deviceName) {
    return url;
  }

  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}deviceName=${encodeURIComponent(deviceName)}`;
};
